import Vue from 'vue';
import { guid } from '@/mixins/guid';
import Transfer from './transfer';

export default Vue.component('owned-domain', {
  template: require('./template.html'),
  name: 'owned-domain',
  components: {
    Transfer,
  },
  mixins: [guid],
  props: ['modal', 'current-site', 'toggle-modal'],
  data() {
    return {
      transfer: false,
    };
  },
  methods: {
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    recheckDomainsNested() {
      this.$emit('recheck-domains');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/domains/add-domain/owned/index.js